<template>
  <section class="barocare-b2c-caution" id="barocare-b2c-caution">
    <div class="container">
      <div class="title-area" v-intersect>
        <span class="text-primary">장애인과 어르신을 위한</span>
        <h2 class="text-xl">국내 유일 비대면진료<br>바로돌봄</h2>
      </div>
      <div class="caution-area" v-intersect>
        <ul>
          <li>
            <img class="icon" src="../../assets/pc_barocare_b2c/ico-caution01.png" alt="">
            <strong>비대면진료비 안내</strong>
            <p>비대면진료는 최대 초진 2,500원,<br>재진 100원, 약값 300원 정도의<br>비용 차이가 발생할 수 있습니다.<br><span class="sub-text"><span class="text-primary">*</span> 건강보험 가입자 기준<br>(의료급여 수급권자는 대면진료와 동일)</span></p>
          </li>
          <li>
            <img class="icon" src="../../assets/pc_barocare_b2c/ico-caution02.png" alt="">
            <strong>진료 예약 전<br>신분증 지참</strong>
            <p>의료기관 본인 확인 의무화에 따라<br>경증장애인 (4-6급)은<br>신분증이 필요합니다.<br>진료 예약 전 지참해주세요.</p>
          </li>
          <li>
            <img class="icon" src="../../assets/pc_barocare_b2c/ico-caution03.png" alt="">
            <strong>비대면진료<br>처방 불가 의약품</strong>
            <p>마약류 및 오남용 우려 의약품은<br>비대면진료 처방이 불가합니다.<br><span class="sub-text"><span class="text-primary">*</span> 마약류 및 오남용 우려 의약품 :<br>향정신성의약품, 수면제, 진정제</span></p>
          </li>
          <li>
            <img class="icon" src="../../assets/pc_barocare_b2c/ico-caution04.png" alt="">
            <strong>비대면진료<br>가능 여부</strong>
            <p>대면진료가 필요한 경우<br>의사의 판단에 따라<br>진료가 거부될 수 있습니다.</p>
          </li>
        </ul>
        <div class="btn-area">
          <a 
            href="http://pf.kakao.com/_xhcxkQG/friend"
            target="_blank" title="새창"
            class="btn-medical"
          >진료 예약 바로가기</a>
        </div>
      </div>
    </div>
    <div class="card-banner barocare-b2c-container-md">
      <div class="inquiry-list">
        <dl class="inquiry-item1" v-intersect>
          <dt>고객센터</dt>
          <dd>
            <span class="item">
              <img class="icon" src="../../assets/pc_barocare_b2c/ico-phone.png" alt="전화번호">
              070-8655-2300
            </span>
            <span class="item">
              <img class="icon" src="../../assets/pc_barocare_b2c/ico-clock.png" alt="영업시간">
              평일 09시 - 18시
            </span>
            <img class="symbol" src="../../assets/pc_barocare_b2c/img-inquiry1.png" alt="">
          </dd>
        </dl>
        <a class="inquiry-item2" href="http://pf.kakao.com/_xhcxkQG/friend" target="_blank" title="새창" v-intersect>
          <dl>
            <dt>카카오 채널 추가<br> 바로가기</dt>
            <dd>
              <span class="link">                
                채널 바로가기
                <img class="icon" src="../../assets/pc_barocare_b2c/ico-plus.png" alt="+">
              </span>
              <img class="symbol" src="../../assets/pc_barocare_b2c/img-kakao-channel.png" alt="">
            </dd>
          </dl>
        </a>
        <dl class="inquiry-item3" v-intersect>
          <dt>바로돌봄 코디<br>카카오톡 1:1 채팅 상담 바로가기</dt>
          <dd>
              휴대폰 카메라로 우측 QR 코드를 스캔하세요
              <img class="symbol" src="../../assets/pc_barocare_b2c/img-kakao-qrcode.png" alt="QR코드 : https://pf.kakao.com/_xoDxeJG/chat">
          </dd>
        </dl>
      </div>
    </div>
  </section>
</template>

<script>
export default {  
  name: 'BarocareB2cCaution',
  directives: {
    intersect: {
      // 요소가 DOM에 삽입될 때 호출됩니다.
      inserted(el) {
        const options = {
          root: null, // 뷰포트를 기본값으로 설정
          rootMargin: '0px', // 뷰포트의 마진은 0
          threshold: 0.1 // 10%가 보일 때 콜백이 실행
        };
        const callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('visible');
            } else {
              el.classList.remove('visible');
            }
          });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(el); // 해당 요소를 관찰 시작
      }
    }
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cCaution.vue